import React from 'react';

const Loader = () => (
  <div className="flex items-center justify-center border border-gray-300 dark:border-gray-700 p-4 rounded-lg shadow">
    <div className="w-12 h-12 border-4 border-dashed border-emerald-500 rounded-full animate-spin"></div>
  </div>
);

export default Loader;
